import { Icon } from "@iconify/react";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { LoginSuccess } from "../utils/redux/slices/authSlice";
import VerifyMsgComponent from "./child/VerifyMsgComponent";
import { useConfig } from "../utils/ConfigContext.jsx";

const SignInLayer = () => {

  const [ step, setStep ] = useState("signin");
  const [ user_name, setUser_name ] = useState("");
  const [ password, setPassword ] = useState("");
  const [ error, setError ] = useState({ user_name: "", password: "", general: "" });
  const [ isLoading, setIsLoading ] = useState(false); // Loading state

  const dispatch = useDispatch();
  const { API_BASE_URL } = useConfig();

  const handleSignIn = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    let validationErrors = { user_name: "", password: "", general: "" };
    if (!user_name) validationErrors.user_name = "Username is required";
    if (!password) validationErrors.password = "Password is required";
    if (validationErrors.user_name || validationErrors.password) {
      setIsLoading(false);

      return setError(validationErrors);
    }
    // Start loading

    try {
      console.log(JSON.stringify({ user_name, password }));
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ user_name, password }),
      });

      const data = await response.json();

      if (response.ok) {
        dispatch(LoginSuccess({
          user_name: user_name,
        }));
        setStep("verifyMsg"); // Move to VerifyMsgComponent
      } else {
        setError({ ...validationErrors, general: data.message || "Login failed" });
      }
    } catch (error) {
      setError({ ...validationErrors, general: "Network error" });
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  return (
    <section className="auth bg-base d-flex flex-wrap align-items-center">
      <div className="auth-left d-lg-block d-none">
        <div className="d-flex align-items-center flex-column h-100 justify-content-center">
          <img
            src="assets/images/auth/auth-img.png"
            alt=""
            style={{ height: '100vh', objectFit: 'cover' }}
          />
        </div>
      </div>
      <div className="auth-right py-24 px-24 d-flex flex-column">
        <div className="max-w-464-px mx-auto w-100">
          {step === "signin" && (
            <>
              <div>
                <Link to="/" className="mb-24" style={{ width: "75px" }}>
                  <img src="assets/images/logo.webp" alt="" />
                </Link>
                <h4 className="mb-12">Sign In to your Account</h4>
                <p className="mb-32 text-secondary-light text-lg">
                  Welcome back! please enter your details
                </p>
              </div>
              <form onSubmit={handleSignIn}>
                <div className="icon-field mb-16">
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="mdi:account" />
                  </span>
                  <input
                    type="text"
                    className="form-control h-56-px bg-neutral-50 radius-12"
                    placeholder="Username"
                    value={user_name}
                    onChange={(e) => setUser_name(e.target.value)}
                  />
                  {error.user_name && (
                    <small className="text-danger">{error.user_name}</small>
                  )}
                </div>
                <div className="position-relative mb-20">
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="solar:lock-password-outline" />
                    </span>
                    <input
                      type="password"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="your-password"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    {error.password && (
                      <small className="text-danger">{error.password}</small>
                    )}
                  </div>
                </div>
                {error.general && (
                  <div className="text-danger mb-3">{error.general}</div>
                )}
                {/* Commented-out Remember Me and Forgot Password section */}
                {/* <div className='d-flex justify-content-between gap-2'>
                  <div className='form-check style-check d-flex align-items-center'>
                    <input
                      className='form-check-input border border-neutral-300'
                      type='checkbox'
                      id='remember'
                    />
                    <label className='form-check-label' htmlFor='remember'>
                      Remember me
                    </label>
                  </div>
                  <Link to='#' className='text-primary-600 fw-medium'>
                    Forgot Password?
                  </Link>
                </div> */}
                <button
                  type="submit"
                  className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32 fixed-size-button"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <span className="flex items-center justify-center">
                      <svg
                        className="animate-spin h-4 w-4 mr-4"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        style={{ width: "20px", height: "20px" }}
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v8H4z"
                        ></path>
                      </svg>
                      Signing In...
                    </span>
                  ) : (
                    'Sign In'
                  )}
                </button>
              </form>
            </>
          )}

          {step === "verifyMsg" && <VerifyMsgComponent />}
        </div>
      </div>
    </section>
  );
};

export default SignInLayer;